<template>
  <h2 class="screen_out">상세페이지</h2>
  <article
    id="mainContent"
    class="content-article content_detail"
  >
    <div class="wrap_detail">
      <div class="area_title">
        <span
          v-if="detailKind === 'news'"
          class="sub_title"
          >{{ newsDetailType }}</span
        >
        <span
          v-if="detailKind === 'case'"
          class="sub_title"
          >{{ props.detailData.partnerName }}</span
        >

        <h3 class="tit_detail">{{ props.detailData.title }}</h3>
      </div>
      <!-- 여기 에디터 컨텐츠 영역 -->
      <div
        class="area_editor"
        v-html="props.detailData.content"
      ></div>
      <!-- 태그, 공유하기 버튼 -->
      <div class="area_bottom">
        <ul class="list_tag">
          <li
            v-for="(item, index) in props.detailData.tag"
            :key="`${index}_tag`"
          >
            <NuxtLink
              :to="`/search?searchKeyword=${item.name}`"
              class="link_tag"
              >{{ `#${item.name}` }}</NuxtLink
            >
          </li>
        </ul>
        <button
          class="btn_share"
          @click="shareLayer.openShareLayer({ shareUrl, shareTitle, shareImage })"
        >
          공유하기
        </button>
      </div>
      <!-- 관련서비스 -->
      <div
        v-if="props.detailData.listRelated"
        class="area_service"
      >
        <strong class="tit_service">관련 서비스</strong>
        <ul class="list_service">
          <li
            v-for="(item, index) in props.detailData.listRelated"
            :key="`${index}_service`"
          >
            <NuxtLink
              :to="`/service/${item.linkUrl}`"
              class="link_service"
            >
              <span class="sub_service">{{ item.businessName }}</span>
              <em class="name_service">{{ item.serviceName }}</em>
              <p
                class="desc_service"
                v-html="item.description"
              ></p>
              <span class="txt_link">자세히 보기</span>
              <div class="wrap_thumb">
                <img
                  :src="item.thumbnail"
                  alt=""
                  class="img_service"
                />
              </div>
            </NuxtLink>
          </li>
        </ul>
      </div>
      <!-- 이전글 다음글 -->
      <div class="area_around">
        <NuxtLink
          v-if="prevContent"
          :to="`/${detailKind}/${prevContent.id}`"
          class="link_around type_before"
        >
          <span class="sub_around">이전글</span>
          <span class="tit_around">{{ prevContent.title }}</span>
        </NuxtLink>
        <NuxtLink
          v-if="nextContent"
          :to="`/${detailKind}/${nextContent.id}`"
          class="link_around type_after"
        >
          <span class="sub_around">다음글</span>
          <span class="tit_around">{{ nextContent.title }}</span>
        </NuxtLink>
      </div>
      <!-- 목록으로 버튼 영역 -->
      <div class="area_btn">
        <ButtonBasic
          :nameBtn="'목록으로'"
          :link="`/${detailKind}`"
          :style="'type_white'"
        />
      </div>
      <!-- 배너영역 -->
    </div>
    <div class="area_banner">
      <BannerConsult :logInfo="{ page: 'detail', name: '상세페이지' }" />
    </div>
  </article>
</template>
<script setup>
import { useShareOpen } from '/stores/store';
const shareLayer = useShareOpen();

const props = defineProps({
  detailData: {
    type: Object,
    default() {
      return {};
    },
  },
  detailKind: {
    type: String,
    default: '',
  },
});

const newsDetailType = computed(() => {
  switch (props.detailData.newsType) {
    case 'REPORT':
      return '언론보도';
      break;
    case 'INSIGHT':
      return '인사이트';
      break;
    case 'NOTICE':
      return '알립니다';
      break;
    default:
      return '언론보도';
      break;
  }
});

const shareUrl = computed(() => {
  return location?.href;
});

const shareTitle = computed(() => {
  return props.detailData.title;
});
const shareImage = computed(() => {
  return props.detailData.thumbnail
    ? props.detailData.thumbnail
    : 'https://t1.kakaocdn.net/dkt_corp/service/temp_default_250123.png';
});

const prevContent = computed(() => {
  return props.detailData.prevContent;
});

const nextContent = computed(() => {
  return props.detailData.nextContent;
});
</script>
<style lang="scss" scoped>
.wrap_detail {
  max-width: 1104px;
  margin: 110px auto 0;
  padding: 0 40px;
}
.area_title {
  text-align: center;
  .tit_detail {
    overflow: hidden;
    margin-top: 24px;
    font-size: 40px;
    letter-spacing: -0.5px;
    word-break: keep-all;
    word-wrap: break-word;
  }
  .sub_title {
    font-size: 18px;
    line-height: 33px;
    letter-spacing: -0.22px;
    font-weight: 700;
    color: #4c4c4c;
  }
}
.area_editor {
  margin-top: 80px;
  word-break: break-all;
}
.area_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 80px;
  .list_tag {
    margin: -8px 0 0 -8px;
    li {
      display: inline-block;
      vertical-align: top;
      margin: 8px 0 0 8px;
    }
    .link_tag {
      display: inline-block;
      padding: 0 16px;
      line-height: 42px;
      font-size: 16px;
      color: #202020;
      border: 1px solid #e5e5e5;
      border-radius: 21px;
      &:hover {
        border-color: #e9e9e9;
        background-color: #e9e9e9;
      }
    }
  }
  .btn_share {
    flex-shrink: 0;
    padding: 0 16px 0 44px;
    line-height: 42px;
    font-size: 16px;
    color: #202020;
    border: 1px solid #e5e5e5;
    border-radius: 21px;
    @include backgroundImage(
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath d='M19 10.667V6m0 0h-4.667M19 6l-7 7m-1.556-7h-1.71c-1.307 0-1.96 0-2.46.254-.439.224-.796.581-1.02 1.02C5 7.774 5 8.427 5 9.734v6.533c0 1.306 0 1.96.254 2.459.224.439.581.796 1.02 1.02.5.254 1.153.254 2.46.254h6.533c1.306 0 1.96 0 2.459-.254.439-.224.796-.581 1.02-1.02.254-.5.254-1.152.254-2.46v-1.71' stroke='%23202020' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E",
      24px 24px,
      top 9px left 16px
    );
  }
}
.area_service {
  margin-top: 80px;
  .tit_service {
    display: block;
    margin-bottom: 24px;
    font-size: 28px;
    line-height: 42px;
    letter-spacing: -0.35px;
  }
  .list_service {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    .link_service {
      position: relative;
      display: block;
      padding: 32px 128px 32px 32px;
      background-color: #f6f5f7;
      border-radius: 16px;
      font-size: 15px;
      line-height: 23px;
      letter-spacing: -0.5px;
    }
    .name_service {
      display: block;
      margin: 8px 0;
      font-size: 20px;
      font-weight: 700;
    }
    .desc_service {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      margin-bottom: 24px;
    }
    .txt_link {
      display: inline-block;
      vertical-align: top;
      padding-right: 28px;
      line-height: 24px;
      @include backgroundImage(
        "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.146 16.707a.5.5 0 1 0 .708.707l4.95-4.95a.5.5 0 0 0 .14-.434.5.5 0 0 0-.14-.434l-4.95-4.95a.5.5 0 1 0-.708.707l4.677 4.677-4.677 4.677z' fill='%234C4C4C'/%3E%3C/svg%3E",
        24px 24px,
        top right
      );
    }
    .wrap_thumb {
      overflow: hidden;
      position: absolute;
      top: 24px;
      right: 32px;
      @include setSize(72px, 72px);
      border-radius: 16px;
      img {
        width: 100%;
      }
    }
  }
}
.area_around {
  margin-top: 80px;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  .link_around {
    display: flex;
    align-items: center;
    padding: 24px 60px;
    font-size: 16px;
    line-height: 26px;
    & + .link_around {
      border-top: 1px solid #e1e1e1;
    }
    &.type_before {
      .sub_around {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.5 1 7 6H0l3.5-5z' fill='%235887FF'/%3E%3C/svg%3E");
      }
    }
    &.type_after {
      .sub_around {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.5 7 7 2H0l3.5 5z' fill='%235887FF'/%3E%3C/svg%3E");
      }
    }
  }
  .sub_around {
    flex-shrink: 0;
    margin-right: 40px;
    padding-right: 16px;
    color: #5887ff;
    background-position: center right;
    background-size: 8px 8px;
    background-repeat: no-repeat;
  }
  .tit_around {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
.area_btn {
  margin-top: 80px;
  text-align: center;
}
.area_banner {
  margin-top: 120px;
}
@media screen and (max-width: 1023px) {
  .area_service {
    .list_service {
      grid-template-columns: 1fr;
    }
  }
  .area_banner {
    margin-top: 80px;
  }
}
@media screen and (max-width: 811px) {
  .wrap_detail {
    margin-top: 40px;
    padding: 0 20px;
  }
  .area_title {
    .tit_detail {
      margin-top: 16px;
      font-size: 22px;
      letter-spacing: -0.28px;
    }
    .sub_title {
      font-size: 15px;
      line-height: 23px;
      letter-spacing: -0.5px;
    }
  }
  .area_editor {
    margin-top: 48px;
  }
  .area_bottom {
    overflow: hidden;
    display: block;
    margin-top: 40px;
    .list_tag {
      margin-bottom: 16px;
      .link_tag {
        padding: 0 12px;
        line-height: 34px;
        font-size: 14px;
        border-radius: 17px;
      }
    }
    .btn_share {
      float: right;
      padding: 0 12px 0 32px;
      line-height: 34px;
      font-size: 14px;
      border-radius: 17px;
      background-size: 16px 16px;
      background-position: top 8px left 12px;
    }
  }
  .area_service {
    margin-top: 40px;
    .tit_service {
      margin-bottom: 16px;
      font-size: 18px;
      line-height: 33px;
      letter-spacing: -0.22px;
    }
    .list_service {
      display: grid;
      grid-template-columns: 1fr;
      gap: 24px;
      .link_service {
        padding: 20px;
        border-radius: 8px;
        font-size: 14px;
        line-height: 21px;
      }
      .name_service {
        margin: 4px 0 10px;
        font-size: 18px;
      }
      .desc_service {
        margin-bottom: 16px;
      }
      .wrap_thumb {
        top: 20px;
        right: 20px;
        @include setSize(48px, 48px);
      }
    }
  }
  .area_around {
    .link_around {
      padding: 24px 8px;
    }
    .sub_around {
      margin-right: 16px;
    }
  }
  .area_btn {
    margin-top: 48px;
  }
}
</style>
